define(
    'viewmodels/secured/libraries/settings/folder/FolderActions',[
        "providers/dataprovider",
        "i19n!i19n/strings"
    ], 
    function(dataProvider, i19n) {

        FolderActions.prototype.permissionsEnum =
        {
            none: 0,
            rename: 1,
            add: 2,
            remove: 4,
            addDocument: 8,
            accessControl: 16,
            share: 32
        };

        function FolderActions(templateId) {
            var self = this;
        
            //self.treeview = {};
            self.treeNode = {};
            //self.showMenu = ko.observable(false).extend({ notify: 'always' });
            self.errors = ko.observableArray();
            self.permissions = ko.observable(self.permissionsEnum.none);

            //self.showMenu.subscribe(function (show) {
            //    self.permissions(self.permissionsEnum.none);
            //});

            self.clearErrors = function() {
                self.errors([]);
            };

            self.add = ko.asyncCommand({
                canExecute: function () {
                    return true;
                    return (self.permissions() & self.permissionsEnum.add);
                },
                execute: function (menuItem, complete) {
                    self.treeNode.add(function (callbacks) {
                        var data = callbacks.data;
                        var d = callbacks.data.d;

                        if (d.templateId == undefined && d.parentId == undefined) {
                            //main node
                            dataProvider
                            .templatefolders
                            .createFolder(templateId, data.name, data.id)
                            .done(function (id) {
                                var node = { parentId: null, templateId: data.id, id: id, text: data.name, docCount: '' };

                                callbacks.success(node);

                                setTimeout(function () {
                                    self.treeNode.select(node);
                                }, 100);
                            })
                            .fail(function (e) {
                                //e.stopPropagation = true;
                                callbacks.fail();
                                console.warn(e);
                            });

                        } else if (
                            (d.templateId != null && d.parentId == null) ||
                            (d.templateId != null && d.parentId != null)) {
                            //second node
                            //third nodes
                            dataProvider
                            .templatefolders
                            .addFolder(templateId, data.name, data.id)
                            .done(function (id) {
                                var node = { parentId: data.id, templateId: d.templateId, id: id, text: data.name, docCount: '' };

                                callbacks.success(node);

                                setTimeout(function () {
                                    self.treeNode.select(node);
                                }, 100);
                            })
                            .fail(function (e) {
                                //e.stopPropagation = true;
                                callbacks.fail();
                                console.warn(e);
                            });
                        }
                    });
                }
            });


            self.rename = ko.asyncCommand({
                canExecute: function () {
                    return true;
                    //return (self.permissions() & self.permissionsEnum.rename);
                },
                execute: function (menuItem, complete) {
                    self.treeNode.rename(function (callbacks) {
                        var data = callbacks.data;
                        var d = callbacks.data.d;

                        if (d.templateId == undefined && d.parentId == undefined) {
                            //main node
                            callbacks.fail();
                            toastr.error("Not allowed to rename root folder", i19n.to.error, { newestOnTop: false, fadeOut: 300, timeOut: 20000 });
                        } else if (
                            (d.templateId != null && d.parentId == null) ||
                            (d.templateId != null && d.parentId != null)) {
                            //second node
                            //third nodes
                            dataProvider
                            .templatefolders
                            .renameFolder(templateId, data.id, data.name)
                            .done(function (result) {

                                callbacks.success();

                                //for testing. node selection
                                //setTimeout(function () {
                                //    var itm = self.treeview.dataSource.get(d.id);
                                //    var nod = self.treeview.findByUid(itm.uid);
                                //    self.treeview.select(nod);
                                //}, 5000);
                            })
                            .fail(function (e) {
                                //e.stopPropagation = true;
                                callbacks.fail();
                                console.warn(e);
                            });
                        }
                    });
                }
            });

            self.remove = ko.asyncCommand({
                canExecute: function () {
                    return true;
                   //return (self.permissions() & self.permissionsEnum.remove);
                },
                execute: function (menuItem, complete) {
                    self.treeNode.remove(function (callbacks) {
                        var data = callbacks.data;
                        var d = callbacks.data.d;

                        if (d.templateId == undefined && d.parentId == undefined) {
                            //main node

                        } else if (
                            (d.templateId != null && d.parentId == null) ||
                            (d.templateId != null && d.parentId != null)) {
                            //second node
                            //third nodes
                            dataProvider
                            .templatefolders
                            .deleteFolder(templateId, data.id)
                            .done(function () {
                                callbacks.success();
                            })
                            .fail(function (e) {
                                //e.stopPropagation = true;
                                callbacks.fail();
                                console.warn(e);
                            });
                        }
                    });
                }
            });

            self.moveDocuments = ko.asyncCommand({
                canExecute: function () {
                    return true;
                },
                execute: function (menuItem, complete) {
                    complete();
                }
            });
            self.moveDocuments.visible = function () {
                return false;
            };

            self.copyDocuments = ko.asyncCommand({
                canExecute: function () {
                    return true;
                },
                execute: function (menuItem, complete) {
                    complete();
                }
            });
            self.copyDocuments.visible = function () {
                return false;
            };

            self.showAllDocuments = ko.asyncCommand({
                canExecute: function () {
                    return true;
                },
                execute: function (menuItem, complete) {
                    complete();
                }
            });
            self.showAllDocuments.visible = function () {
                return true;
            };
            self.showAllDocuments.isSelected = ko.observable(false);

            self.accessControlCommand = ko.asyncCommand({
                canExecute: function () {
                    return true;
                },
                execute: function (menuItem, complete) {
                    complete();
                }
            });
            self.accessControlCommand.visible = function () {
                return false;
            };

            self.showDeletedCommand = ko.asyncCommand({
                canExecute: function () {
                    return true;
                },
                execute: function (menuItem, complete) {
                    complete();
                }
            });
            self.showDeletedCommand.visible = function () {
                return false;
            };

            self.select = function (n) {
            
            };
        }    

        return FolderActions;

        function hasDuplicateName(names, name) {
            //console.log('-----');
            //console.log('find : ' + name + ' in');
            //console.log(names);
            //console.log('-----');

            if (names.length == 0 || name.length == 0) return false;

            var w = _.chain(names)
                .pluck('text')
                .without(undefined)
                .map(function (itm) { return { text: itm.toLowerCase() } })
                .where({ text: name.toLowerCase() })
                .value();

            return w.length != 0;
            //var w;

            //w = _.pluck(names, 'text');
            //console.log('pluck'); console.log(w);

            //w = _.without(w, undefined);
            //console.log('without'); console.log(w);

            //w = _.map(w, function (itm) { return { text: itm.toLowerCase() } });
            //console.log('map'); console.log(w);

            //w = _.where(w, { text: name.toLowerCase() });
            //console.log('where'); console.log(w);

            //console.log('-----');

            //console.log('has duplicate: ' + w !== undefined);
            //console.log(w);
            //return w.length != 0;
        }
    });
